var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.875 9.74412C16.8755 9.93511 16.8265 10.123 16.7329 10.2894C16.6392 10.4559 16.5041 10.5953 16.3406 10.694L6.21 16.8914C6.0392 16.996 5.84358 17.0531 5.64334 17.0568C5.44309 17.0605 5.24549 17.0107 5.07094 16.9125C4.89805 16.8158 4.75402 16.6748 4.65368 16.5041C4.55333 16.3333 4.50029 16.1388 4.5 15.9408V3.54748C4.50029 3.3494 4.55333 3.15497 4.65368 2.98419C4.75402 2.81341 4.89805 2.67243 5.07094 2.57577C5.24549 2.47757 5.44309 2.42776 5.64334 2.43147C5.84358 2.43518 6.0392 2.49227 6.21 2.59686L16.3406 8.7942C16.5041 8.89297 16.6392 9.03236 16.7329 9.19882C16.8265 9.36528 16.8755 9.55314 16.875 9.74412Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVoice);
export default __webpack_public_path__ + "static/media/Play-voice.94bc48b9f353c16dffde47a902156709.svg";
export { ForwardRef as ReactComponent };